import Joi from "joi";

const BedSubCategorySchema = Joi.object({
  bedCategory: Joi.string().trim().required().messages({
    "string.empty": "Bed Category is required.",
  }),
  name: Joi.string().trim().required().messages({
    "string.empty": "Name is required.",
  }),
  item: Joi.string().trim().required().messages({
    "string.empty": "Item is required.",
  }),
  cost: Joi.number().min(0).optional().messages({
    "number.base": "Cost must be a number.",
    "number.min": "Cost cannot be negative.",
  }),
}).unknown(true);

export default BedSubCategorySchema;
